import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBettingMarket } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";

export const useDeleteBettingMarket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteBettingMarket(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingMarketsQueryKeys.BettingMarkets] });
    },
  });
};
